import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  console.log(STORE_KEY, INITIAL_STATE);
  const appState = state || redux.store.getState();
  console.log(appState?.[STORE_KEY] || INITIAL_STATE);
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectMachineData = state => selectState(state).data;
export const selectCellLaneData = state => selectState(state).lanes;
export const selectMachineDetailsData = state => selectState(state).machineDetailsData;
export const selectMachineMaintenanceData = state => selectState(state).maintenanceData;
export const selectMachineMaintenanceRecordsData = state => selectState(state).machineMaintenanceRecordsData;
export const selectMachineSafetyChecklistData = state => selectState(state).machineSafetyChecklistData;
export const selectMaintenanceRecordData = state => selectState(state).maintenanceRecordsData;
export const selectCellHistoryData = state => selectState(state).cellHistoryData;
export const selectedProduct = state => selectState(state).product;
export const getPrinters = state => selectState(state).printersdata;
export const selectMachineLoading = state => selectState(state).loading;
export const selectfetchMachineLoading = state => selectState(state).machineLoading;
export const selectMachineError = state => selectState(state).error;
export const selectMachineFilterVisible = state => selectState(state).filterVisible;
export const selectMachineFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredMachines = createSelector(
  [selectMachineData, selectMachineFilters],
  (data, { searchText, lane }) => {
    return data.filter(entry => {
      const matchesSearchText = Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      );

      const matchesLane = !lane || lane === 'ALL' || entry.lane === lane;

      return matchesSearchText && matchesLane;
    });
  },
);
